<template>
  <Modal :open="open" @close="close">
    <h2 class="text-lg font-semibold mb-4 text-center w-full">Veuillez spécifier la prise en charge</h2>

    <HandlingTypeForm v-if="open" :claim="claim" @submitted="close" />
  </Modal>
</template>

<script>
import { Modal } from "@estaly/ui";
import HandlingTypeForm from "@/components/claim/details/action/HandlingTypeForm.vue";

export default {
  name: "HandlingTypeSpecificationModal",

  components: { Modal, HandlingTypeForm },
  props: ["open", "claim"],
  emits: ["close"],

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
